<div class="mat-select-search-inner" [class.mat-select-search-inner-multiple]="matSelect.multiple">
    <input matInput
           class="mat-select-search-input"
           #searchSelectInput
           (keydown)="onKeydown($event)"
           (input)="onInputChange(searchSelectInput.value)"
           autocomplete="off"
           placeholder="{{'seachPlaceholder' | translate}}" />
    <mat-icon class="mat-select-search-icon">search</mat-icon>
</div>

<div *ngIf="filter && matSelect.options?.length === 0" class="mat-select-search-no-entries-found">
    <span [translate]="'searchNoEntriesFound'">No options found</span>
</div>
